import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-fw-details-popup',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './fw-details-popup.component.html',
  styleUrl: './fw-details-popup.component.scss',
})
export class FwDetailsPopupComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
